<template>
	<BaseCmsPage :fetch="{slug: '/404/'}" v-slot="{page}" @load="onPageLoad">
		<CmsPageLayout>
			<template #breadcrumb_section>
				<CmsBreadcrumbs v-if="page?.breadcrumbs" :items="page.breadcrumbs" />
			</template>

			<h1><BaseCmsLabel tag="div" code="404_h1" /></h1>
			<BaseCmsLabel tag="div" code="404_description" />
			<br />
			<p>
				<NuxtLink class="btn" to="/"><BaseCmsLabel code="return_back" /></NuxtLink>
			</p>
		</CmsPageLayout>
	</BaseCmsPage>
</template>

<script setup>
	//gtm
	const gtm = useGtmBB();

	function onPageLoad(data) {
		if(!data) return;
		gtm.pageView({
			url: data?.url || '',
			title: data?.title || '',
		});
	}
</script>
